module.exports = __webpack_public_path__ + "8185eb3059c46e4169ce107dfcf85950.svg";